import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../../../shared/shared.module';
import { EmployeeService } from '../../../../../shared/services/employee.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../../../../shared/services/alert.service';
import { AuthService } from '../../../../../shared/services/auth.service';
import { FinalExamEvaluatorSubjectService } from "../../../../../shared/services/final-exam-evaluator-subject.service";
import { PermissionConstant } from '../../../../../shared/constants/permission-constant';
import JsBarcode from 'jsbarcode';

@Component({
  selector: 'vex-previous-student-results',
  standalone: true,
  imports: [
    FormsModule,
    NgForOf,
    NgIf,
    ReactiveFormsModule,
    SharedModule,
  ],
  templateUrl: './view-result.component.html',
  styleUrl: './view-result.component.scss'
})
export class ViewResultComponent implements OnInit, AfterViewInit {
  @ViewChild('barcode') barcodeEl!: ElementRef;
  searchForm: FormGroup;
  user: any;
  rolePermissions: any = [];
  id: any;
  sessionId: any;
  semesterYear: any;
  result_type: any;
  loader: any = false;
  results: any;

  constructor(
    private employeeService: EmployeeService,
    private router: Router,
    public alertService: AlertService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private finalExamEvaluatorSubjectService: FinalExamEvaluatorSubjectService
  ) {
    this.authService.self().subscribe((data: any) => {
      if (data && data.id) {
        this.user = data;
        if (this.user?.user_type === 'EMPLOYEE') {
          this.getUserPermission();
        } else if (this.user?.user_type === 'SUPER_ADMIN' || this.user?.user_type === 'ADMIN') {
          this.route.params.subscribe((params: any) => {
            if (params && params.id && params.session_id && params.value && params.result_type) {
              this.id = params.id;
              this.sessionId = params.session_id;
              this.semesterYear = params.value;
              this.result_type = params.result_type;
              this.get();
            }
          });
        } else {
          this.router.navigateByUrl('/home');
        }
      }
    });
  }

  ngOnInit(): void {
    this.refresh();
  }

  // Mirrors the backend blade: session id > 14 -> first design (monospace / Lucida Console),
  // session id <= 14 -> second design (serif / Times New Roman + TlwgTypewriter values).
  get useFirstDesign(): boolean {
    return Number(this.sessionId) > 14;
  }

  ngAfterViewInit(): void {
  }

  generateBarcode(): void {
    setTimeout(() => {
      if (this.barcodeEl?.nativeElement) {
        // Match the blade: CODE39, with width/height that differ per design.
        const isFirstDesign = this.useFirstDesign;
        JsBarcode(this.barcodeEl.nativeElement,
          this.results?.student_data?.admission_no || 'N/A',
          {
            format: 'CODE39',
            lineColor: '#000000',
            width: isFirstDesign ? 0.9 : 0.7,
            height: isFirstDesign ? 25 : 40,
            displayValue: true,
            fontSize: 10,
            fontOptions: 'bold'
          }
        );
      }
    }, 300); // ✅ 300ms gives Angular time to render *ngIf
  }

  refresh(): void {}

  getUserPermission(): void {
    this.employeeService.detail(this.user.unique_id).subscribe((data: any) => {
      if (data && data['employee_details'] && data['employee_details']['designation'] && data['employee_details']['designation']['designation_permissions']) {
        const permissionData: any = data['employee_details']['designation']['designation_permissions'];
        let rolePermissions: any = [];
        permissionData.forEach((subPermission: any) => {
          if (subPermission && subPermission['sub_permission'] && subPermission['sub_permission']['meta']) {
            rolePermissions.push(subPermission['sub_permission']['meta']);
          }
        });
        this.rolePermissions = rolePermissions;
        const canAccess = this.user?.designation_status === 'COE' ||
          rolePermissions.includes(PermissionConstant.RESULTS_PREVIOUS_RESULT_STUDENT_VIEW_RESULT);
        if (!canAccess) {
          this.router.navigateByUrl('/home');
          return;
        }
        this.route.params.subscribe((params) => {
          if (params && params.id && params.session_id && params.value && params.result_type) {
            this.id = params.id;
            this.sessionId = params.session_id;
            this.semesterYear = params.value;
            this.result_type = params.result_type;
            this.get();
          }
        });
      }
    });
  }

  get(): void {
    let key = this.result_type === "SEMESTER" ? "semester" : "year";
    const params: any = {
      session_id: this.sessionId ?? "",
      [key]: this.semesterYear ?? ""
    };
    this.results = [];
    this.loader = true;
    this.finalExamEvaluatorSubjectService.viewResult(params, this.id).subscribe((data: any) => {
      if (data && data.student_result_details && data.student_data) {
        this.results = data;
        this.loader = false;
        this.generateBarcode();
      }
    }, () => {
      this.loader = false;
    });
  }
}
